module.exports = {
	displayExpansion: function (val) {
		if (val) {
			return "expanded";
		}
		return "collapsed";
	}
};


// WEBPACK FOOTER //
// ./src/helpers/expander-helpers.js